/**
 * The app's frame with nothing in it yet (catalyst/sidebar-layout.tsx's
 * background, and its white content area), shown while a signed-in reload
 * restores the session and loads the user: the shell fills in where it
 * already stands rather than replacing a spinner.
 *
 * index.html carries the same markup, so the frame paints before any of the
 * app's code has arrived; BootSkeleton.test.ts keeps the two identical. Only
 * for a stored session: someone signed out sees the sign-in screen, never the
 * frame of an app they are not in.
 */
export default function BootSkeleton() {
    return (
        <div
            data-boot-skeleton=""
            aria-hidden="true"
            className="flex h-full min-h-svh w-full flex-col bg-white lg:bg-zinc-50 dark:bg-zinc-900 dark:lg:bg-zinc-950"
        >
            <div className="flex flex-1 flex-col pb-2 lg:pl-[4.3rem] lg:pr-2 lg:pt-2">
                <div className="flex-1 lg:rounded-lg lg:bg-white lg:ring-1 lg:ring-zinc-200 dark:lg:bg-zinc-900 dark:lg:ring-white/10"></div>
            </div>
        </div>
    );
}

/** Whether Amplify has a session stored, the one hint there is before it has restored it. */
export function hasStoredSession(): boolean {
    return Object.keys(localStorage).some((key) =>
        key.startsWith("CognitoIdentityServiceProvider."),
    );
}
